import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Icon,
  InputLeftElement,
  InputRightElement,
  InputGroup,
  useColorModeValue as mode,
} from '@chakra-ui/react';
import React, { useContext } from 'react';
import { useModule, StarberryComponentContext } from '@starberry/components';

export const InputField = React.forwardRef(
  (
    {
      label,
      error,
      rightIcon: RightIcon,
      leftIcon: LeftIcon,
      value,
      defaultValue,
      type,
      name,
      autocomplete,
      inputProps,
      required,
      onChange,
      onBlur,
      disabled,
    },
    ref
  ) => {
    const Input = useModule('Input');
    const { constants } = useContext(StarberryComponentContext);
  
    return (
      <FormControl isInvalid={error !== undefined}>
        {label && (
          <FormLabel
            _focus={{ color: mode('blue.600', 'blue.300') }}
            position="absolute"
            fontSize={14}
            fontWeight="normal"
            color={mode('gray.500', 'white')}
            top="-3"
            insetStart="2"
            bg={{ base: mode('white', 'gray.800'), md: mode('white', 'gray.700') }}
            zIndex={2}
            px="2"
          >
            {label}
            {required && ' *'}
          </FormLabel>
        )}
        <InputGroup>
          {LeftIcon && (
            <InputLeftElement pointerEvents="none" top="3px">
              <Icon as={LeftIcon} w={6} h={6} m={3} color={constants.colors.icons} />
            </InputLeftElement>
          )}
          <Input
            name={name}
            autocomplete={autocomplete}
            defaultValue={defaultValue}
            disabled={disabled}
            type={type}
            {...inputProps}
            value={value}
            ref={ref}
            onChange={() => onChange}
            onBlur={() => onBlur}
          />
          {RightIcon && (
            <InputRightElement pointerEvents="none" top="3px">
              <Icon as={RightIcon} w={6} h={6} m={3} color={constants.colors.icons} />
            </InputRightElement>
          )}
        </InputGroup>
        {error?.message && <FormErrorMessage>{error.message}</FormErrorMessage>}
      </FormControl>
    );
  }
);

export default React.memo(InputField);
